const inits = {
  mapLoader: false,
  appLoader: true,
}

const LoaderReducer = (s = inits, action) => {
  const {payload} = action
  switch (action.type) {
    case '_LOADER':
      return { ...s, [payload[0]]: payload[1] }

    default:
      return s;
  }
};
export default LoaderReducer
